export default __webpack_public_path__ + "static/media/stats-up.55b6e4fe.svg";